<template>
  <div>
    <div class="pending-gathering-container">
      <div class="item-info">
        <h3>
          Número da Solicitação:
          <span>{{ solicitationId }}</span>
        </h3>
        <h3 class="date">
          Data prevista de coleta:
          <span>{{ collectionDate }}</span>
        </h3>
      </div>
      <button class="approve-btn" @click="sendApprovedSolicitation()">
        Aprovar
      </button>
      <button class="refuse-btn" @click="sendRefusedSolicitation()">
        Recusar
      </button>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";

export default {
  name: "PendingGathering",
  props: ["inverseOrder", "scheduleDate", "solicitationId"],
  components: {
    Datepicker
  },
  data: function() {
    return {
      isDateRefused: false,
      isSendClicked: false,
      ptBR,
      clientSuggestedDate: "",
      collectionDate: ""
    };
  },
  methods: {
    sendRefusedSolicitation() {
      this.$emit("refusedSolicitation");
    },
    sendApprovedSolicitation() {
      this.$emit("approvedSolicitation");
    }
  },
  created() {
    this.collectionDate = this.scheduleDate;
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

.pending-gathering-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 22px 10px;
  background-color: $grey4;
  width: 100%;
  min-width: 800px;
  box-shadow: 1px 2px 5px $grey4;
  user-select: none;
  border-bottom: 2px solid $grey8;
  border-left: 3px solid $red1;
  padding: 10px;

  .item-info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    h3 {
      margin: 0;
      padding: 7px;
      font-weight: 400;
      white-space: nowrap;
      font-size: 16px;

      span {
        color: $orange1;
        font-weight: 600;
      }
    }
  }

  .refuse-btn {
    background-color: $orange1;
    border: none;
    padding: 0;
    margin-right: 7px;
    height: 36px;
    width: 150px;
    font-size: 14px;
    text-transform: uppercase;
    color: $white;
    outline: none;
    cursor: pointer;

    &:hover {
      transition: 0.7s;
      background-color: $orange2;
    }
  }

  .approve-btn {
    background-color: $green1;
    border: none;
    padding: 0;
    margin-right: 7px;
    height: 36px;
    width: 150px;
    font-size: 14px;
    text-transform: uppercase;
    color: $white;
    outline: none;
    cursor: pointer;

    &:hover {
      transition: 0.7s;
      background-color: $green2;
    }
  }
}

.error {
  margin-left: 50px;
  color: red;
}
</style>
